import React from "react";
import {Navigate} from "react-router-dom";

//Dashboard
const DashboardEcommerce = React.lazy(() => import("../pages/DashboardEcommerce"));

//APi Key
const APIKey = React.lazy(() => import("../pages/APIKey/index"));

//login
const Login = React.lazy(() => import("../pages/Authentication/Login"));
const ForgetPasswordPage = React.lazy(() => import("../pages/Authentication/ForgetPassword"));
const ChangePasswordPage = React.lazy(() => import("../pages/Authentication/ChangePassword"));
const Logout = React.lazy(() => import("../pages/Authentication/Logout"));
const Register = React.lazy(() => import("../pages/Authentication/Register"));

// User Profile
const UserProfile = React.lazy(() => import("../pages/Authentication/user-profile"));

const MerchantDocumentsTable = React.lazy(() => import('../pages/Documents/Documents/MerchantDocumentsTable'));
const MerchantDocumentView = React.lazy(() => import('../pages/Documents/Documents/MerchantDocumentView'));
const DocumentOfflineTable = React.lazy(() => import('../pages/Documents/DocumentOffline/DocumentOfflineTable'));
const DocumentOfflineEdit = React.lazy(() => import('../pages/Documents/DocumentOffline/DocumentOfflineEdit'));
const DocumentPendingTable = React.lazy(() => import('../pages/Documents/DocumentPending/DocumentPendingTable'));
const DocumentFailedTable = React.lazy(() => import('../pages/Documents/DocumentFailed/DocumentFailedTable'));
const MyDataReferenceTablesTable = React.lazy(() => import('../pages/Documents/DocumentTypes/MyDataReferenceTablesTable'));
const MerchantDocumentSignaturesTable = React.lazy(() => import('../pages/Documents/Signatures/MerchantDocumentSignaturesTable'));
const SearchTable = React.lazy(() => import('../pages/Documents/Search/SearchTable'));

const MerchantAccountView = React.lazy(() => import('../pages/Merchant/MerchantAccount/MerchantAccountView'));
const MerchantsTable = React.lazy(() => import('../pages/Merchant/Merchants/MerchantsTable'));
const MerchantLocationsTable = React.lazy(() => import('../pages/Merchant/MerchantLocations/MerchantLocationsTable'));
const MerchantCreditsTable = React.lazy(() => import('../pages/Merchant/MerchantCredits/MerchantCreditsTable'));

const UsersTable = React.lazy(() => import('../pages/Users/UsersTable'));
const UserAccountView = React.lazy(() => import('../pages/Users/UserAccountView'));
const Alt404 = React.lazy(() => import("../pages/AuthenticationInner/Errors/Alt404"));
const Offlinepage = React.lazy(() => import("../pages/AuthenticationInner/Errors/Offlinepage"));
const Cover404 = React.lazy(() => import("../pages/AuthenticationInner/Errors/Cover404"));
const Error500 = React.lazy(() => import("../pages/AuthenticationInner/Errors/Error500"));
const Basic404 = React.lazy(() => import("../pages/AuthenticationInner/Errors/Basic404"));
const ForgetPasswordMailSend = React.lazy(() => import("../pages/Authentication/ForgetPasswordMailSend"));
const SwaggerUIComponent = React.lazy(() => import("../pages/Pages/SwaggerUI/SwaggerUIComponent"));
const MerchantDocumentViewV2 = React.lazy(() => import("../pages/Documents/Documents/MerchantDocumentViewV2"));
const MyDataApiTestTemplates = React.lazy(() => import("../pages/MyDataApiTests/MyDataApiTestTemplates"));
const MyDataApiTestRunner = React.lazy(() => import("../pages/MyDataApiTests/MyDataApiTestRunner"));

const authProtectedRoutes = [

    // dashboard
    {path: "/dashboard", component: <DashboardEcommerce/>},
    {path: "/index", component: <DashboardEcommerce/>},

    {path: "/documents/documents-all", component: <MerchantDocumentsTable/>},
    {path: "/documents/view/:id", component: <MerchantDocumentView/>},
    {path: "/documents/offline", component: <DocumentOfflineTable/>},
    {path: "/documents/offline/:id", component: <DocumentOfflineEdit/>},
    {path: "/documents/search", component: <SearchTable/>},
    {path: "/documents/pending", component: <DocumentPendingTable/>},
    {path: "/documents/failed", component: <DocumentFailedTable/>},
    {path: "/documents/types", component: <MyDataReferenceTablesTable tableKey="invoice-types"/>},
    {path: "/mydata/reference-tables/:tableKey", component: <MyDataReferenceTablesTable/>},
    {path: "/documents/signatures", component: <MerchantDocumentSignaturesTable/>},

    {path: "/merchants/me", component: <MerchantAccountView/>},
    {path: "/merchants/my-profile", component: <Navigate to="/merchants/me" replace/>},
    {path: "/merchants/:id", component: <MerchantAccountView/>},
    {path: "/merchants/locations", component: <MerchantLocationsTable/>},
    {path: "/merchants", component: <MerchantsTable/>},
    {path: "/merchants/credits", component: <MerchantCreditsTable/>},

    {path: "/users", component: <UsersTable/>},
    {path: "/users/:id", component: <UserAccountView/>},
    // {path: "/users/change-password", component: <ChangePasswordPage/>},

    {path: "/mydata-api-test-templates", component: <MyDataApiTestTemplates/>},
    {path: "/mydata-api-tests", component: <MyDataApiTestRunner/>},

    // //Api Key
    {path: "/apps-api-key", component: <APIKey/>},

    //User Profile
    {path: "/profile", component: <UserProfile/>},

    // this route should be at the end of all other routes
    // eslint-disable-next-line react/display-name
    {
        path: "/",
        exact: true,
        component: <Navigate to="/dashboard" replace/>,
    },
    {path: "*", component: <Navigate to="/alt-404" replace/>},
];

const publicRoutes = [
    // Authentication Page
    {path: "/logout", component: <Logout/>},
    {path: "/login", component: <Login/>},
    {path: "/forgot-password", component: <ForgetPasswordPage/>},
    {path: "/forgot-mail-send", component: <ForgetPasswordMailSend/>},
    {path: "/register", component: <Register/>},
    // {path: "/change-password", component: <ChangePasswordPage/>},
    {path: "/reset-password/:token", component: <ChangePasswordPage/>},
    // {path: "/document/:id", component: <MerchantDocumentView/>},
    {path: "/document/:id", component: <MerchantDocumentViewV2/>},
    {path: "/document-v2/:id", component: <MerchantDocumentViewV2/>},

    {path: "/alt-404", component: <Alt404/>},
    {path: "/basic-404", component: <Basic404/>},
    {path: "/cover-404", component: <Cover404/>},
    {path: "/error-500", component: <Error500/>},
    {path: "/offline", component: <Offlinepage/>},
    {path: "/api", component: <SwaggerUIComponent/>},



];

export {authProtectedRoutes, publicRoutes};
